import { type RouteRecordRaw } from 'vue-router';

import { permissionHelper } from '@/helpers/auth/permissions.helper';

import system_routes from './system.route';

import type { ModuleLink } from '@bv/router';

export const modules: ModuleLink[] = [
  {
    icon: 'bvi-dashboard',
    route: { name: 'dashboard' },
    title: 'GLOBAL.NAVS.DASHBOARD',
    moduleName: 'dashboard',
  },
  {
    icon: 'bvi-text-bubble',
    route: { name: 'conversations' },
    title: 'GLOBAL.NAVS.conversations_trans',
    visible: true,
  },
  {
    icon: 'bvi-contacts',
    route: { name: 'contacts' },
    title: 'GLOBAL.NAVS.contacts_trans',
    moduleName: 'contacts',
  },
  {
    icon: 'bvi-ai-solid',
    route: { name: 'ai' },
    title: 'GLOBAL.NAVS.ai_trans',
    moduleName: 'ai-chat',
    badge: {
      text: 'GLOBAL.NAVS.beta_trans',
      color: 'var(--green-500)',
      textColor: 'white',
    },
  },
  {
    icon: 'bvi-announcement',
    route: { name: 'campaigns' },
    title: 'GLOBAL.NAVS.campaigns_trans',
    moduleName: 'broadcast',
  },
  {
    icon: 'bvi-sitemap',
    route: { name: 'workflows' },
    title: 'GLOBAL.NAVS.workflows_trans',
    moduleName: 'workflow',
  },
  {
    icon: 'bvi-chart-line',
    route: { name: 'reports' },
    title: 'GLOBAL.NAVS.all_reports_trans',
    moduleName: 'chat-reports',
  },
  {
    icon: 'bvi-setting',
    route: { name: 'settings' },
    title: 'GLOBAL.NAVS.SETTINGS',
    moduleName: 'chat-settings',
  },
];

export const mainRoute: RouteRecordRaw = {
  path: '/',
  name: 'main',
  beforeEnter: (to, from, next) => {
    if (to.path === '/') {
      return next(
        permissionHelper.checkPermissionAuth('read-dashboard') ? { name: 'dashboard' } : { name: 'conversations' },
      );
    }
    next();
  },
  children: [
    system_routes,
    {
      path: '/survey',
      name: 'survey',
      meta: {
        public: true,
        layout: 'blank',
      },
      component: () => import('@/views/Survey/SurveyView.vue'),
    },
  ],
};
